import { render, staticRenderFns } from "./BbsAssistant.vue?vue&type=template&id=0b4c09c0&scoped=true&"
import script from "./BbsAssistant.vue?vue&type=script&lang=js&"
export * from "./BbsAssistant.vue?vue&type=script&lang=js&"
import style0 from "./BbsAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BbsAssistant.vue?vue&type=style&index=1&id=0b4c09c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c09c0",
  null
  
)

export default component.exports